import React from 'react';
import { connect } from 'react-redux';
import { options } from 'config/reactRedux';
import Link from 'components/link';
import withStyles from 'isomorphic-style-loader/withStyles';
import icons from 'config/icons';
import { getEdition } from 'selectors/getEdition';
import { getSocialLinks, getBabbelRSSUrl } from 'utils/url';
import { LANGUAGES } from 'config/types/prop';

import styles from './socialLinks.css';

export const SocialLinks = ({ currentEdition }) => {
  const links = {
    ...getSocialLinks(currentEdition),
    rss: 'rss',
  };

  return (
    <nav className={styles.wrapper}>
      <ul className={styles.list}>
        {Object.keys(links).map((serviceName) => (
          <li className={styles.item} key={serviceName}>
            <Link
              to={'rss' === serviceName ? getBabbelRSSUrl(currentEdition) : links[serviceName]}
              className={styles.link}
            >
              <img
                alt={`${serviceName} icon`}
                className="lazyload"
                data-src={icons[serviceName]}
                height="25"
                width="25"
              />
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

SocialLinks.propTypes = {
  currentEdition: LANGUAGES.isRequired,
};

const mapStateToProps = (state) => ({
  currentEdition: getEdition(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);
const wrapWithStyles = withStyles(styles);

export default withRedux(wrapWithStyles(SocialLinks));
